import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { SearchUserApi } from "../../apis/user/search_user_api";
import PlaceHolder from "../../utils/placeholder";

export default function Search() {
    const [searchData, setSearchData] = useState([]);
    const [searchApi, setSearchApi] = useState(API_STATUS);
    const [noData, setNodata] = useState(false);
    const [searchKey, setSearchKey] = useState("");

    useEffect(() => {
        setSearchData([]);
        if (!searchApi.isLoader && !searchApi.isError && searchApi.data != null) {
            if (searchApi.data.status === 1) {
                setSearchData(searchApi.data.data);
            } else {
                setNodata(true);
            }
        }
    }, [searchApi]);

    const doSearch = () => {
        if (searchKey !== "") {
            setSearchData([]);
            setNodata(false);

            SearchUserApi({ 'search_key': searchKey }, setSearchApi);
        }
    }

    return <div className="sm:w-[397px] w-full bg-white shadow-lg md:!left-[73px] hidden !left-0 dark:bg-dark2 dark:border1 max-md:bottom-[57px]" uk-drop="animation: uk-animation-slide-left-small , uk-transform-origin-center-left ;animate-out: true; pos: left ; mode:click; offset: 9">
        <div className="md:h-screen overflow-y-auto h-[calc(100vh-120px)]">

            <div className="px-5 py-4 space-y-5 border-b border-gray-100 dark:border-slate-700">
                <h3 className="md:text-xl text-lg font-medium mt-3 text-black dark:text-white">Search</h3>

                <div className="relative -mx-1">
                    <Link
                        onClick={doSearch}
                        className="absolute right-3" style={{ bottom: 8 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" className="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                    </Link>

                    <input onChange={(v) => {
                        setSearchKey(v.target.value);
                    }} type="text" placeholder="Search" value={searchKey} className="bg-transparen w-full !py-2 !rounded-lg" style={{ paddingRight: 40 }} />
                </div>

            </div>
            {
                noData &&
                <div className="p-3">No result found for {searchKey}</div>
            }
            {
                searchApi.isLoader &&
                <PlaceHolder />
            }
            {
                searchData.length > 0 &&
                <div class="p-2 space-y-2 dark:text-white">

                    <div class="flex items-center justify-between py-2.5 px-3 font-semibold">
                        <h4>Search Result</h4>
                        <button type="button" class="text-blue-500 text-sm">Clear all</button>
                    </div>
                    {
                        searchData.map((item, i) =>
                            <a key={i} href={'/profile/' + item.userId} class="relative flex items-center gap-3 p-2 duration-200 rounded-xl hover:bg-secondery">
                                <img src={item.userPic} alt="" class="bg-gray-200 rounded-full w-10 h-10" />
                                <div class="fldex-1 min-w-0">
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <h4 class="font-medium text-sm text-black dark:text-white">  {item.firstName + ' ' + item.lastName} </h4>
                                        {
                                            item['subId'] != null && item['subPayStatus'] == 1 &&
                                            <div style={{ color: '#17ce85ff', fontSize: 14,paddingLeft:5 }}><i class="fa fa-check-circle" aria-hidden="true"></i></div>
                                        }
                                    </div>
                                    <div class="text-xs text-gray-500 font-normal mt-0.5 dark:text-white-80"> {item.username} </div>
                                </div>
                            </a>
                        )
                    }




                </div>
            }


        </div>
    </div>
}